import { Checkbox as BaseCheckbox } from "@base-ui/react/checkbox";
import { cva, type VariantProps } from "class-variance-authority";
import { Check, Minus } from "lucide-react";
import { cn } from "../lib/cn";

const checkboxVariants = cva(
  "inline-flex shrink-0 items-center justify-center border text-accent-fg transition-colors duration-fast focus-ring data-checked:border-accent data-checked:bg-accent data-indeterminate:border-accent data-indeterminate:bg-accent data-disabled:cursor-not-allowed data-disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "size-4 rounded-sm border-border-strong bg-bg hover:border-fg-faint",
        /** Round, slightly larger: for completing a row-level item. */
        task: "size-[18px] rounded-full border-border-strong bg-transparent hover:border-accent hover:bg-accent-muted",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface CheckboxProps
  extends Omit<BaseCheckbox.Root.Props, "className">, VariantProps<typeof checkboxVariants> {
  className?: string;
}

export function Checkbox({ className, variant, ...props }: CheckboxProps) {
  return (
    <BaseCheckbox.Root
      data-slot="checkbox"
      className={cn(checkboxVariants({ variant }), className)}
      {...props}
    >
      <BaseCheckbox.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current data-unchecked:hidden"
      >
        {props.indeterminate ? (
          <Minus className="size-3" strokeWidth={3} />
        ) : (
          <Check className="size-3" strokeWidth={3} />
        )}
      </BaseCheckbox.Indicator>
    </BaseCheckbox.Root>
  );
}
